<aw-texts-table
  #textTable
  [texts]="webTextStore.texts()"
  [textType]="ETextType.Web"
  [isLoading]="webTextStore.isLoading()"
  [headline]="cmsTextProvider.allTexts.webHeadline"></aw-texts-table>
